<form [formGroup]="newsletterForm" (ngSubmit)="onSubmit()" class="newsletter-form">
  <!--Field email-->
  <div class="newsletter-form__email">
    <bmcore-input-b
      themeInputClass="theme-input__newsLetterBlock"
      themeInputPlaceholderClass="theme-input__newsLetterBlock-placeholder"
      formControlName="email"
      [title]="lg.forms.email"
      [initialValue]="''"
      [type]="'email'"
      [controlFormName]="'email'"
      [tag]="'input'"
    >
    </bmcore-input-b>
  </div>

  <!--Field name-->
  <div class="newsletter-form__name">
    <bmcore-input-b
      themeInputClass="theme-input__newsLetterBlock"
      themeInputPlaceholderClass="theme-input__newsLetterBlock-placeholder"
      formControlName="name"
      [title]="lg.forms.name"
      [initialValue]="''"
      [type]="'text'"
      [controlFormName]="'name'"
      [tag]="'input'"
    >
    </bmcore-input-b>
  </div>

  <div class="newsletter-form__btn-container">
    <bmcore-button
      themeBtnClass="theme-btn__newsLetterBlock"
      themeIconClass="theme-icon__newsLetterBlock"
      styleName="center"
      title="{{ lg.button.subscribeNewsletter }}"
      icon="btv-icon-btn-telegram"
    >
    </bmcore-button>
  </div>
</form>
